var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:{
  'page-section': true,
  'page-section--full': _vm.full,
  'page-section--padding': _vm.padding,
}},[_c('div',{staticClass:"page-section__container"},[_c('div',{staticClass:"page-section__slot"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }